export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.round((d - today) / (1000 * 60 * 60 * 24));
}

// green > 40, orange 15-40, red < 15 (and overdue)
export function alertLevel(days) {
  if (days === null || days === undefined) return "none";
  if (days > 40) return "green";
  if (days >= 15) return "orange";
  return "red";
}

export const alertStyles = {
  green: "bg-[#4ADE80] text-slate-900 border-slate-900",
  orange: "bg-[#FB923C] text-slate-900 border-slate-900",
  red: "bg-[#EF4444] text-white border-slate-900",
  none: "bg-slate-100 text-slate-500 border-slate-900",
};

export const alertLabel = {
  green: "OK",
  orange: "Bientôt",
  red: "Urgent",
  none: "Non défini",
};

export function vidangeLevel(remaining) {
  if (remaining === null || remaining === undefined) return "none";
  if (remaining > 5000) return "green";
  if (remaining > 0) return "orange";
  return "red";
}
